/* eslint-disable react/no-array-index-key, react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/article-heading.scss';

const propTypes = {
    item: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ArticleHeading = ({ item, className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.banner} style={{ backgroundImage: `url(${item.image.url}` }}>
                    <div className={styles.filter} />
                </div>
                <div className={styles.textContainer}>
                    <div className={styles.text}>

                        <div
                            className={styles.title}
                            dangerouslySetInnerHTML={{ __html: item.title }}
                        />
                        <div className={styles.author}>{item.author}</div>
                        <div className={styles.subheading}>{item.subheading}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ArticleHeading.propTypes = propTypes;
ArticleHeading.defaultProps = defaultProps;

export default ArticleHeading;
